import React, { useState, useCallback } from "react";
import styles from './Calendar.module.css'
import { Button, Dropdown } from 'react-bootstrap';
import { convertDateTimeToApplicationTime } from '../../../util/functions'
import Flatpickr from 'react-flatpickr';
import heLocale from 'flatpickr/dist/l10n/he';
import { useTranslation } from "react-i18next";
const Calendar = (props) => {
    const { showCalendar, onToggelCalendar, onConfirmDateClicked } = props

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [t] = useTranslation('common')
    const dateSelectedHandler = useCallback((selectedDates) => {
        setSelectedDate(selectedDates[0]);
    }, []);

    const onCancelBtnClickedHandler = useCallback(() => {
        setSelectedDate(new Date());
        onToggelCalendar();
    }, [onToggelCalendar])

    const onConfirmBtnClickedHandler = useCallback(() => {
        onConfirmDateClicked(selectedDate)
        onToggelCalendar()
    }, [selectedDate, onConfirmDateClicked, onToggelCalendar])

    return <Dropdown show={showCalendar} className={`${styles['calendar-dropdown']}`} onToggle={onCancelBtnClickedHandler} drop="left">
        <Dropdown.Toggle
            className={`${styles['dropdown-toggle']} ${styles['caret-off']}`}
        >
        </Dropdown.Toggle>
        <Dropdown.Menu>
            <div>
                <Flatpickr
                    id="popup-notification-time-picker"
                    options={{
                        locale: heLocale.he, // use hebrew locale
                        time_24hr: true,
                        enableTime: true,
                        defaultDate: selectedDate,
                        minDate: 'today',
                        inline: true, // display a smaller calendar directly in the dropdown
                        dateFormat: 'd/m/Y H:i', // format date and time in hebrew
                    }}
                    value={selectedDate}
                    onChange={dateSelectedHandler}
                />
                <div className={styles['button-container']}>
                    <Button onClick={onCancelBtnClickedHandler} variant="secondary" > {t('cancel')} </Button>
                    <Button onClick={onConfirmBtnClickedHandler} variant="success"> {t('confirm')} </Button>
                </div>
            </div>
        </Dropdown.Menu>
    </Dropdown>
}
export default Calendar